import { ReactNode } from 'react';

export type BodyTableCellProps = {
  children: ReactNode;
  onClick?: () => void;
};

export { default as BodyTableCell } from './BodyTableCell';
